import(/* webpackMode: "eager" */ "/test-project/app/globals.css");
import(/* webpackMode: "eager" */ "/test-project/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/test-project/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/test-project/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/test-project/components/ui/tooltip.tsx")